import { render, staticRenderFns } from "./OrderExtraService.vue?vue&type=template&id=46014706&"
import script from "./OrderExtraService.vue?vue&type=script&lang=js&"
export * from "./OrderExtraService.vue?vue&type=script&lang=js&"
import style0 from "./OrderExtraService.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports